import React from "react";
import { useEffect } from "react";
import Classification from "../Components/Classification/Classification";
function Classificationpage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Classification />
    </>
  );
}

export default Classificationpage;
